export const OrganizationDetailsFormIsVatDefinedOptions = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'No',
  },
];

export const NotAVatPayerLabel = 'Not a VAT payer';
